import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Box, Button, Card, Container, Grid, Stack, Table, TableBody, TableContainer, Typography } from '@mui/material';
// components
// sections
// mock
import moment from 'moment';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ButtonAction from 'src/components/Button.js/SaveButton';
import EmtyData from 'src/components/emty-data';
import Iconify from 'src/components/iconify/Iconify';
import ComboBox from 'src/components/Input/ComboBox';
import DatePickerValue from 'src/components/Input/DatePickerValue';
import TextInput from 'src/components/Input/TextInput';
import Loader from 'src/components/loader/loader';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import { sendRequest, serviceList } from 'src/utils';
import ItemListBorrowDevice from './ItemListBorrowDevice';
import ConfirmFixDeviceModel from './modal/ConfirmFixDevice';
import RequestFixDeviceModel from './modal/RequestFixDevice';
import ChangeDeviceTakeOrBorrow from '../RequestDevices/modal/ChangeDeviceTakeOrBorrow';
import TakeDevice from '../RequestDevices/modal/TakeDevice';

// ----------------------------------------------------------------------
const STATUS_COLOR = {
    igb: 'success',
    ebr: 'error',
    rde: 'info',
    cdr: 'primary',
    7: 'warning',
    8: 'warning',
    9: 'success',
    10: 'info',
    11: 'primary',
    12: 'error',
    13: 'success',
};
export default function ListBorrowingDevice({ device_cd }) {
    const { t } = useTranslation();
    const getRef = useRef(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);

    // const [checkReturn, setcheckReturn] = useState(false);
    const tableRef = useRef(null);
    const dataRef = useRef(null);
    const [valueSearch, setValueSearch] = useState({
        status: 'ebr',
        key: '',
        startDay: moment().subtract(1, 'months').format('YYYYMMDD'),
        endDay: moment().format('YYYYMMDD'),
    });
    const [totalData, setTotalData] = useState(0);
    const lastIdRef = useRef(0);
    const [visibleRequestFixDevice, setVisibleRequestFixDevice] = useState(false);
    const [visibleConfirmFixDevice, setVisibleConfirmFixDevice] = useState(false);

    const [openChangeRequestDevice, setOpenChangeRequestDevice] = useState(false);
    const [openTakeDevice, setOpenTakeDevice] = useState(false);
    const params = useParams();
    const ARR_STATUS = [
        { label: t('all'), value: 'all' },
        { label: t('return'), value: 'igb' },
        { label: t('borrowed'), value: 'ebr' },
        { label: t('reported_damaged'), value: 'rde' },
        { label: t('admin_progresing_fixed'), value: '7' },
        { label: t('admin_is_under_review'), value: '8' },
        { label: t('success'), value: '9' },
        { label: t('finished_fix'), value: 'cdr' },
    ];

    const return_name_status = (bussiness) => {
        switch (bussiness) {
            case 'igb':
                return t('return');
            case 'ebr':
                return t('not_returned');
            case 'rde':
                return t('reported_damaged');
            case 'cdr':
                return t('finished_fix');
            case '7':
                return t('admin_progresing_fixed');
            case '8':
                return t('admin_is_under_review');
            case '9':
                return t('success');
            case '10':
                return t('waiting_confirm_change');
            case '11':
                return t('confirm_change');
            case '12':
                return t('reject_change');
            case '13':
                return t('done_change');
            default:
                return '';
        }
    };

    const TABLE_HEAD = [
        { id: 'name', label: t('device'), alignRight: false },
        { id: 'name', label: t('code_device'), alignRight: false },
        { id: 'company', label: t('info'), alignRight: false },
        { id: 'Thao tác', label: t('borrower'), alignRight: false },
        { id: 'user_assign_nm', label: t('requester_name_device'), alignRight: false },
        { id: 'quantity_category', label: t('quantity_category'), alignRight: false },
        { id: 'role', label: t('status'), alignRight: false },
        { id: 'role', label: t('note_'), alignRight: false },
        ['cdr', 'rde', 'all', '7'].includes(valueSearch.status) && {
            id: 'qtyRequest',
            label: t('qtyRequest'),
            alignRight: false,
        },
        ['cdr', 'rde', 'all', '7'].includes(valueSearch.status) && {
            id: 'damaged_before_use_device',
            label: t('device_error_when'),
            alignRight: false,
        },
        ['cdr', 'all'].includes(valueSearch.status) && {
            id: 'userApproveOrReject',
            label: t('userApproveOrReject'),
            alignRight: false,
        },
        ['cdr', 'all'].includes(valueSearch.status) && {
            id: 'dateApproveReject',
            label: t('dateApproveReject'),
            alignRight: false,
        },
        ['rde', 'cdr', 'all', '7'].includes(valueSearch.status) && {
            id: 'note_repair',
            label: t('note_repair'),
            alignRight: false,
        },
        ['rde', 'cdr', 'all', '7'].includes(valueSearch.status) && {
            id: 'new_place_fixed',
            label: t('new_place_fixed'),
            alignRight: false,
        },
        ['all', '7', 'cdr'].includes(valueSearch.status) && {
            id: 'date_fixing',
            label: t('date_fixing'),
            alignRight: false,
        },
        ['cdr', 'all'].includes(valueSearch.status) && {
            id: 'price_repaired_fixed',
            label: t('price_repaired_fixed'),
            alignRight: false,
        },
        ['ebr', 'all'].includes(valueSearch.status) && {
            id: '3',
            label: t('day_borrow'),
            alignRight: false,
        },
        ['ebr', 'all'].includes(valueSearch.status) && {
            id: 'quantity_give',
            label: t('day_need_give'),
            alignRight: false,
        },
        ['igb', 'all'].includes(valueSearch.status) && {
            id: '4',
            label: t('day_give'),
            alignRight: false,
        },
        ['ebr', 'all', 'rde', '7'].includes(valueSearch.status) && {
            id: 'action',
            label: '',
            alignRight: false,
            stickyEnd: true,
        },
    ];

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    const handleOnChange = (e, key) => {
        setValueSearch((prev) => ({ ...prev, [key]: e }));
    };

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [valueSearch.status, 9999999999999, valueSearch.startDay, valueSearch.endDay, valueSearch.key];
        sendRequest(serviceList.getListEbrByBussiness, InVal, getDataResult, true, timeOutFunct, 40000);
    }, [valueSearch]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            if (device_cd) {
                const dataRes = message.proc_data.rows[0]?.o_1.filter((data) => data.device_cd === device_cd) || [];
                if (dataRes?.length) lastIdRef.current = dataRes[dataRes.length - 1].id;
                setTableData(dataRes);
                setTotalData(message.proc_data.rowTotal || 0);
                console.log('dataRes', dataRes);
            } else {
                const dataRes = message.proc_data.rows[0]?.o_1 || [];
                if (dataRes?.length) lastIdRef.current = dataRes[dataRes.length - 1].id;
                setTableData(dataRes);
                setTotalData(message.proc_data.rowTotal || 0);
                console.log('dataRes', dataRes);
            }
            setTotalData(message.proc_data.rowTotal || 0);
        }
    };

    const getDataNext = (lastId = lastIdRef.current) => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [valueSearch.status, lastId, valueSearch.startDay, valueSearch.endDay, valueSearch.key];
        sendRequest(serviceList.getListEbrByBussiness, InVal, getDataNextResult, true, timeOutFunct, 40000);
    };

    // region getDataNextResult
    const getDataNextResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataRes = message.proc_data.rows[0]?.o_1 || [];
            if (dataRes?.length) lastIdRef.current = dataRes[dataRes.length - 1].id;
            setTableData([...tableData, ...dataRes]);
            setTotalData(message.proc_data.rowTotal || 0);
            console.log('dataRes', dataRes);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t('ds_muon_tb'),
        sheet: t('ds_muon_tb'),
    });

    return (
        <>
            {!device_cd && (
                <Helmet>
                    <title> {t('ds_muon_tb')} </title>
                </Helmet>
            )}

            <Container>
                {/* Báo hư */}
                <RequestFixDeviceModel
                    visible={visibleRequestFixDevice}
                    setVisible={setVisibleRequestFixDevice}
                    callBackFunct={() => {
                        setVisibleRequestFixDevice(false);
                        getData();
                    }}
                    data={dataRef.current}
                    idPermission={parseInt(params.idPermission)}
                />
                {/* Xác nhận sửa */}
                <ConfirmFixDeviceModel
                    visible={visibleConfirmFixDevice}
                    setVisible={setVisibleConfirmFixDevice}
                    callBackFunct={() => {
                        setVisibleConfirmFixDevice(false);
                        getData();
                    }}
                    data={dataRef.current}
                    idPermission={parseInt(params.idPermission)}
                />
                <ChangeDeviceTakeOrBorrow
                    visible={openChangeRequestDevice}
                    setVisible={setOpenChangeRequestDevice}
                    callBackFunct={() => {
                        setOpenChangeRequestDevice(false);
                        getData();
                    }}
                    idPermission={parseInt(params.idPermission)}
                    data={dataRef.current}
                />
                <TakeDevice
                    visible={openTakeDevice}
                    setVisible={setOpenTakeDevice}
                    callBackFunct={() => {
                        setOpenTakeDevice(false);
                        getData();
                    }}
                    idPermission={parseInt(params.idPermission)}
                    data={dataRef.current}
                    where="borrow"
                />
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('ds_muon_tb')}
                    </Typography>{' '}
                    <Button
                        variant="contained"
                        startIcon={<Iconify icon="mingcute:file-export-line" />}
                        onClick={onDownload}
                    >
                        {t('export_excel')}
                    </Button>
                </Stack>{' '}
                {!device_cd && <Breadcrumb paths={[{ label: t('ds_muon_tb'), url: '#', navigate: false }]} />}
                <Loader loading={getFlags} />
                <Card>
                    <Grid padding={'20px 10px'} container spacing={2} style={{}}>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <TextInput
                                size="medium"
                                getValue={(e) => handleOnChange(e, 'key')}
                                label={t('searchDevice')}
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <ComboBox
                                label={t('filter_status')}
                                sizeCbb="medium"
                                displayLabel="label"
                                valueEqual="value"
                                valueSelect={ARR_STATUS.find((ele) => ele.value === valueSearch.status)}
                                getValue={(e) => handleOnChange((e || {})['value'] || 'all', 'status')}
                                selectOption={ARR_STATUS}
                                required
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue
                                label={t('start_day')}
                                valueChange={valueSearch.startDay}
                                getValue={(e) => handleOnChange(e, 'startDay')}
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue
                                label={t('to_day')}
                                valueChange={valueSearch.toDay}
                                getValue={(e) => handleOnChange(e, 'endDay')}
                            />
                        </Grid>
                        <Grid item xl={2} md={2} sm={12} style={{ width: '100%', marginTop: 9 }}>
                            <ButtonAction
                                fullWidth
                                onClick={getData}
                                size="large"
                                type={'search'}
                                title={t('search')}
                                sx={{ padding: 3.3 }}
                            />
                        </Grid>
                    </Grid>
                    <TableContainer sx={{}}>
                        <Table>
                            <DepartmentListHead
                                order={'asc'}
                                orderBy={'name'}
                                headLabel={TABLE_HEAD.filter((ele) => ele)}
                                rowCount={tableData.length}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => (
                                        <ItemListBorrowDevice
                                            key={index}
                                            item={item}
                                            index={index}
                                            STATUS_COLOR={STATUS_COLOR}
                                            return_name_status={return_name_status}
                                            valueSearch={valueSearch}
                                            dataRef={dataRef}
                                            setVisibleRequestFixDevice={setVisibleRequestFixDevice}
                                            setVisibleConfirmFixDevice={setVisibleConfirmFixDevice}
                                            openButton={true}
                                            setOpenChangeRequestDevice={setOpenChangeRequestDevice}
                                            setOpenTakeDevice={setOpenTakeDevice}
                                        />
                                    ))}
                            </TableBody>
                        </Table>
                        {tableData.length === 0 && <EmtyData />}
                    </TableContainer>
                    <TableContainer>
                        <Table ref={tableRef} sx={{ display: 'none' }}>
                            <DepartmentListHead
                                order={'asc'}
                                orderBy={'name'}
                                headLabel={TABLE_HEAD}
                                rowCount={tableData.length}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => (
                                        <ItemListBorrowDevice
                                            key={index}
                                            item={item}
                                            index={index}
                                            STATUS_COLOR={STATUS_COLOR}
                                            return_name_status={return_name_status}
                                            valueSearch={valueSearch}
                                            dataRef={dataRef}
                                            setVisibleRequestFixDevice={setVisibleRequestFixDevice}
                                            setVisibleConfirmFixDevice={setVisibleConfirmFixDevice}
                                            openButton={false}
                                            setOpenChangeRequestDevice={setOpenChangeRequestDevice}
                                            setOpenTakeDevice={setOpenTakeDevice}
                                        />
                                    ))}
                            </TableBody>
                        </Table>

                        <Box
                            sx={{ position: 'sticky', zIndex: 1000, bottom: 0, backgroundColor: '#f1f3f4' }}
                            display={'flex'}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            paddingLeft={2}
                            // paddingRight={2}
                        >
                            <Stack>
                                <span>
                                    {t('total_row')}: {tableData.length}/{totalData}
                                </span>
                            </Stack>
                            <Button
                                variant="contained"
                                endIcon={<Iconify icon="material-symbols:skip-next-rounded" />}
                                onClick={() => getDataNext()}
                                disabled={tableData.length < totalData ? false : true}
                            >
                                {t('next')}
                            </Button>
                        </Box>
                    </TableContainer>
                </Card>
            </Container>
        </>
    );
}
